import styled from 'styled-components'
import * as FiltersStyle from '../styles'
import { BREAKPOINT_SM } from '../../../theme/ota'

export const Container = styled(FiltersStyle.Container)``

export const TitleContainer = styled(FiltersStyle.TitleContainer)``

export const Title = styled(FiltersStyle.Title)``

export const TitleInfo = styled(FiltersStyle.TitleInfo)``

export const Stars = styled.ul`
  display: flex;
  gap: 10px;
  margin: 0;
  padding: 0;

  @media (max-width: calc(${BREAKPOINT_SM})) {
    justify-content: flex-start;
  }
`
